export const useCheckSelectedTab = () => {
    return (selectedTab: string, originTab: string) => {
        if (selectedTab === originTab) {
            return 'tab Mui-selected';
        } else {
            return 'tab';
        }
    }
}